import _ from 'lodash'
import { useState, useEffect, useCallback } from 'react'
import AuthClient from '@vero/api-client-browser/clients/auth.js'
import { EMAIL_REGEX } from '../utils.js'

export default function (email, setLoading, setError, handleError) {
  const [providers, setProviders] = useState()

  const re = new RegExp(EMAIL_REGEX)
  const authClient = new AuthClient()

  const fetchProviders = useCallback(_.debounce(async (email) => {
    if (re.test(email)) {
      try {
        setLoading(true)
        setProviders(await authClient.listProviders(email))
      } catch (e) {
        await handleError(e)
      } finally {
        setLoading(false)
      }
    } else {
      setProviders(null)
    }
  }, 300), [])

  const hasEmailProvider = () => _.includes(providers?.providers, 'email')
  const isSsoUser = () => !_.isEmpty(providers?.providers) && !hasEmailProvider()

  useEffect(() => {
    setError(null)
    fetchProviders(email)
  }, [email])

  return {
    providers: providers?.providers,
    confirmed: providers?.confirmed,
    hasEmailProvider,
    isSsoUser
  }
}
